const { api_key, error, file_too_big, policy, signature } = gon.filestack;

export default {
  apiKey: api_key,
  error,
  fileTooBig: file_too_big,
  policy,
  signature,
};
